import React, { lazy } from 'react'
import { createBrowserRouter } from 'react-router-dom'

import OneSignalWrapper from 'layout/onesignal-wrapper'
import { privateLoader, publicLoader } from 'router/helper'
import { permissionData } from 'shared/constants'
import allRoutes from 'shared/lib/allRoutes'

const AuthLayout = lazy(() => import('layout/auth-layout'))
const AdminLayout = lazy(() => import('layout/admin-layout'))

const Login = lazy(() => import('app/auth/login'))
const ForgotPassword = lazy(() => import('app/auth/forgot-password'))
const Dashboard = lazy(() => import('app/private/dashboard'))
const SubAdminPage = lazy(() => import('app/private/sub-admin'))
const EndUserListing = lazy(() => import('app/private/end-user'))
const VerificationRequestPage = lazy(() => import('app/private/end-user/verification-request'))
const ProjectsManagementsPage = lazy(() => import('app/private/projects-managements'))
const MaterialManagementsPage = lazy(() => import('app/private/material-managements'))
const StackUpListing = lazy(() => import('app/private/stack-managements'))
const EditStack = lazy(() => import('app/private/stack-managements/edit-stack-up'))
const ViaStructureListing = lazy(() => import('app/private/via-structure'))
const CmsPage = lazy(() => import('app/private/cms'))
const AdminLogsPage = lazy(() => import('app/private/admin-logs'))
const ViaSpanListing = lazy(() => import('app/private/via-spans'))
const ViaSpanDetail = lazy(() => import('app/private/via-spans/spans-detail'))

export const routes = (queryClient) =>
  createBrowserRouter([
    {
      element: (
        <OneSignalWrapper>
          <AuthLayout />
        </OneSignalWrapper>
      ),
      loader: publicLoader,
      children: [
        {
          path: allRoutes.login,
          element: <Login />
        },
        {
          path: allRoutes.forgotPassword,
          element: <ForgotPassword />
        }
      ]
    },
    {
      element: (
        <OneSignalWrapper>
          <AdminLayout />
        </OneSignalWrapper>
      ),
      loader: privateLoader(queryClient),
      children: [
        {
          path: allRoutes.dashboard,
          element: <Dashboard />
        },
        {
          path: allRoutes.subAdmin,
          handle: permissionData.VIEW_SUBADMIN,
          element: <SubAdminPage />
        },
        {
          path: allRoutes.userList,
          handle: permissionData.VIEW_USER,
          element: <EndUserListing />
        },
        {
          path: allRoutes.verificationRequest,
          element: <VerificationRequestPage />
        },
        {
          path: allRoutes.projectsManagements,
          handle: permissionData.VIEW_PROJECT,
          element: <ProjectsManagementsPage />
        },
        {
          path: allRoutes.materialManagements,
          handle: permissionData.VIEW_MATERIAL_LIBRARY,
          element: <MaterialManagementsPage />
        },
        {
          path: allRoutes.stackUpListing,
          handle: permissionData.VIEW_STACKUP,
          element: <StackUpListing />
        },
        {
          path: allRoutes.editStackUp(':iStackupId'),
          handle: permissionData.EDIT_STACKUP,
          element: <EditStack />
        },
        {
          path: allRoutes.viaStructure,
          handle: permissionData.VIEW_VIA_STRUCTURE,
          element: <ViaStructureListing />
        },
        {
          path: allRoutes.cms,
          handle: permissionData.VIEW_CMS,
          element: <CmsPage />
        },
        {
          path: allRoutes.viaSpan,
          handle: permissionData.VIEW_VIA_SPAN,
          element: <ViaSpanListing />
        },
        {
          path: allRoutes.viaSpanDetail(':iViaSpanId'),
          handle: permissionData.EDIT_VIA_SPAN,
          element: <ViaSpanDetail />
        },
        {
          path: allRoutes.adminLogs,
          handle: permissionData.VIEW_LOGS,
          element: <AdminLogsPage />
        }
      ]
    }
  ])
